import { useEffect, useCallback } from 'react'
import useUsers from './users.hook.js'
import usersStore from '../store/users'
import dashbordStore from '../store/dashbord'
import useSettings from './settings.hook.js'

function useInit() {
  const { currentUser } = usersStore
  const { getUsers, getMe } = useUsers()
  const { setInitialSettings } = useSettings()

  const getAllUsers = useCallback(async () => {
    const data = await getUsers()
    usersStore.setUsers(data)
  }, [getUsers])

  const getCurrentUser = useCallback(async () => {
    const me = await getMe()
    const { settings, m_roles } = me

    usersStore.setCurrentUser({
      ...usersStore.currentUser,
      ...me,
      role: m_roles || []
    })

    if(m_roles?.length) {
      const adminRole = m_roles.find(role => role.name === 'Администратор')
      const proStamperRole =  m_roles.find(role => role.name === 'Суперпечатник')
      const headOfProductionRole =  m_roles.find(role => role.name === 'Начальник производства')
      usersStore.setIsAdmin(!!adminRole)
      usersStore.setIsProStamper(!!proStamperRole || !!adminRole)
      usersStore.setIsHeadOfProduction(!!headOfProductionRole || !!adminRole)
    }
    setInitialSettings(settings)
  })

  useEffect(() => {
    getAllUsers()
  }, [])

  useEffect(() => {
    if (currentUser.id) {
      getCurrentUser()
    }
  }, [currentUser.id])
}

export default useInit
